import dayjs from "dayjs";
import {TabMode} from "../../core/views/leftTab"


export const Direction = {
    Vertical: "vertical",
    Horizontal: "horizontal",
}

export const ViewMode = {
    Map: "map",
    List: "list",
}

const AppDataState = {

    apiEndpoint: null,
    direction: Direction.Vertical,
    viewMode: [ViewMode.Map, ViewMode.List],
    user: null,
    env: null,
    columnDefs: null,
    treeInfoModel: null,
    selectedTreeModel: null,
    condition: null,
    filterModel: null,
    tabMode: TabMode.Main,

    treeRefreshTime: dayjs().unix(),
}

export default AppDataState
